import { ListPost } from 'types/PostDetail';
import { Post } from 'types/Post';
import { TYPE as PAGE_TYPE } from '@kontentino/kontentino-constants/Pages';
import { TYPE as POST_TYPE } from '@kontentino/kontentino-constants/Posts';

export const getPostTargetInfoMessage = (selection: ListPost, target: Post) => {
  const isLinkedInSingleListPost =
    selection.page.type === PAGE_TYPE.LINKEDIN &&
    selection.type === POST_TYPE.LINK &&
    !!selection.preview_image?.src;

  if (isLinkedInSingleListPost && target.page.type === PAGE_TYPE.FACEBOOK) {
    return 'To make sure your post will be published with the desired image, please remove the customized image and add it back so the Facebook link ownership can be validated. Otherwise your post will be published with the default image set in the link. ';
  }
};
